import { ReactNode, Suspense } from 'react';

import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { NethoneProvider } from '@sorare/core/src/contexts/nethone/Provider';
import { RiskJsProvider } from '@sorare/core/src/contexts/risk/Provider';
import { lazy } from '@sorare/core/src/lib/retry';

import { Props as PaymentBoxProps } from '../PaymentBox';
import { Props as PaymentDialogProps } from '../PaymentDialog';
import { PaymentProps } from '../PaymentProvider';

const PaymentProvider = lazy(
  async () => import('components/buyActions/PaymentProvider'),
  'ContextProvider'
);
const PaymentBox = lazy(
  async () => import('components/buyActions/PaymentBox'),
  'PaymentBox'
);
const PaymentDialog = lazy(
  async () => import('components/buyActions/PaymentDialog'),
  'PaymentDialog'
);

interface Props {
  fallback?: ReactNode;
  paymentProps: PaymentProps;
  paymentBoxProps?: PaymentBoxProps;
  paymentDialogProps?: PaymentDialogProps;
}

export const LazyPaymentProvider = ({
  paymentProps,
  paymentBoxProps,
  paymentDialogProps,
  fallback = null,
}: Props) => {
  return (
    <Suspense fallback={fallback}>
      <NethoneProvider>
        <RiskJsProvider>
          <PaymentProvider {...paymentProps}>
            <ConditionalWrapper
              wrap={!!paymentDialogProps}
              Wrapper={PaymentDialog}
              props={paymentDialogProps}
            >
              <PaymentBox {...paymentBoxProps} />
            </ConditionalWrapper>
          </PaymentProvider>
        </RiskJsProvider>
      </NethoneProvider>
    </Suspense>
  );
};
